import { type FC, useRef, useState } from "react";

import { cn } from "@/lib/utils";
import { Tooltip, TooltipContent, TooltipTrigger } from "@recobra/ui/tooltip";

/**
 * One line of text that spells itself out in a tooltip, but only while the
 * layout is actually cutting it short. Overflow is measured when the tooltip
 * asks to open, so a resize never leaves a stale answer behind.
 */
export const TruncatedText: FC<{ text: string; className?: string }> = ({ text, className }) => {
  const textRef = useRef<HTMLSpanElement>(null);
  const [isOpen, setIsOpen] = useState(false);
  const isOverflowing = () => {
    const element = textRef.current;

    return !!element && element.scrollWidth > element.clientWidth;
  };

  return (
    <Tooltip open={isOpen} onOpenChange={(open) => setIsOpen(open && isOverflowing())}>
      <TooltipTrigger render={<span ref={textRef} className={cn("block truncate", className)} />}>
        {text}
      </TooltipTrigger>
      <TooltipContent>{text}</TooltipContent>
    </Tooltip>
  );
};
